<template>
    <img src="/images/slogan.png" alt="Logo Vença" class="sm:max-w-[200px] xl:max-w-[50vh] mx-auto pb:hidden"/>
    <!-- <img src="/images/logo.png" alt="Logo Vença" class="sm:max-w-[200px] xl:max-w-[50vh] mx-auto sm:hidden mt-40" /> -->
</template>
